import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"

import type { EditableFields } from "../edit-sheet"

type Update = <K extends keyof EditableFields>(
  key: K,
  value: EditableFields[K],
) => void

// IMP-462: no Identity tab in the drawer — the voice (and the rest of the
// assistant's identity) is account-level, edited on Settings → Identity.
// This tab carries only the greeting.
export function GeneralPanel({
  fields,
  onChange,
}: {
  fields: EditableFields
  onChange: Update
}) {
  return (
    <section className="space-y-2">
      <Label>Greeting</Label>
      <Textarea
        rows={3}
        value={fields.greeting}
        onChange={(e) => onChange("greeting", e.target.value)}
      />
    </section>
  )
}
